var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-content",attrs:{"id":"help"}},[_c('tabs',{attrs:{"transition":0},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('tab',{attrs:{"title":"Actu-SPIADI"}},[_c('news')],1),_c('tab',{attrs:{"title":"FAQ"}},[_c('faq')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }